import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Draggable, CallButtons } from 'libs/ui';
import { closeWindow } from 'store/actions/windows';
import { isCp } from 'libs/design';
import { Close, Content, Header, Tab, TabsBox, Menu } from './window.styled';

export const Window = (props) => {
  const { tabs, activeTab, children, content, defaultPosition, width, header, id, scale = 1 } = props;
  const [selectedTab, setSelectedTab] = useState(activeTab ? activeTab : tabs ? tabs[0].id : '');
  const dispatch = useDispatch();

  const getTabs = () => {
    let tabsArr = [];
    if (tabs) {
      tabsArr = tabs.map((item) => {
        return (
          <Tab key={'tb' + item.id} active={selectedTab === item.id} onClick={() => switchTab(item.id)}>
            {item.text}
          </Tab>
        );
      });
    }

    return tabsArr;
  };

  const getContent = () => {
    // children
    if (children) {
      return children;
    }

    // tab
    if (tabs) {
      if (selectedTab) {
        const Component = content[selectedTab];
        return <Component {...props} />;
      }
      return null;
    }

    const Component = content;
    return <Component {...props} />;
  };

  const switchTab = (tab) => {
    setSelectedTab(tab);
  };

  // render
  const contentEl = getContent();
  const tabsEl = getTabs();
  const withCall = !!tabs && tabs[0].id === 'control';

  return (
    <Draggable width={width} handle=".header" defaultPosition={defaultPosition} scale={scale}>
      <>
        <Header className="header">
          <p>{header}</p>
        </Header>
        <Close href="#" onClick={() => dispatch(closeWindow(id))}>
          {isCp ? (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden>
              <path d="M2 2l10 10M12 2L2 12" />
            </svg>
          ) : (
            <img src="./images/close_icon.png" alt="X" />
          )}
        </Close>
        {!!tabs && (
          <Menu>
            <TabsBox>{tabsEl}</TabsBox>
            {withCall && <CallButtons rackId={id} />}
          </Menu>
        )}
        <Content>{contentEl}</Content>
      </>
    </Draggable>
  );
};
